import kapacitorQueryConfigs from './queryConfigs'
import rules from './rules'
import fluxTasks from './fluxTasks'

export default {
  kapacitorQueryConfigs,
  rules,
  fluxTasks,
}
